import { Component, OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef, Inject, ElementRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { FormArray, FormControl, AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, MinLengthValidator, PatternValidator } from '@angular/forms';
import { LoaderService } from 'app/main/apps/loader/loader.service';
import { first } from 'rxjs/operators';
import { AlertService, AuthenticationService, StorageService } from 'app/main/apps/_services';
import { fuseAnimations } from '@fuse/animations';
import { EncryptionService } from 'app/main/apps/_services/encryption.service';
@Component({
    selector: 'reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
    direction = 'row';
    currentUser: any;
    company_id: any;
    unit_id: any;
    project_id: any;
    project_name: any;
    submitted = false;
    ChangePasswordFormGroup: FormGroup;
    mileStoneGet: any;
    preceeding_activity: any;
    activityGet: any;
    proCompanyUser: any;
    exmemberUser: any;
    //pwdPattern = "^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,12}$";
    activitySrNo: any;
    preActivity_sr_no: any;
    proAllDetails: any;
    projectDetails: any;
    preceeding_activityGet: any;
    dataSourceProActivity: MatTableDataSource<any>;
    checkboxes = [
        {
            "id": "lowercase",
            "label": "a-z",
            "library": "abcdefghijklmnopqrstuvwxyz",
            "checked": true
        }, {
            "id": "uppercase",
            "label": "A-Z",
            "library": "ABCDEFGHIJKLMNOPWRSTUVWXYZ",
            "checked": true
        }, {
            "id": "numbers",
            "label": "0-9",
            "library": "0123456789",
            "checked": true
        }, {
            "id": "symbols",
            "label": "!-?",
            "library": "!@#$%^&*-_=+\\|:;',.\<>/?~",
            //"library": "!@#$%",
            "checked": true
        }
    ]
    dictionary: Array<String>;
    lowercase: Boolean = this.checkboxes[0].checked;
    uppercase: Boolean = this.checkboxes[1].checked;
    numbers: Boolean = this.checkboxes[2].checked;
    symbols: Boolean = this.checkboxes[3].checked;
    passwordLenght = 11;
    buttonLabel: String = "Generate";
    newPasswordGenerate: String;
    // Password length
    private updatePasswordLength(event) {
        this.passwordLenght = event.target.value;
    }
    // Checkbox value
    private updateCheckboxValue(event) {
        if (event.target.id == "lowercase")
            this.lowercase = event.target.checked;
        if (event.target.id == "uppercase")
            this.uppercase = event.target.checked;
        if (event.target.id == "numbers")
            this.numbers = event.target.checked;
        if (event.target.id == "symbols")
            this.symbols = event.target.checked;
    }
    // Copy password to clipboard
    @ViewChild('passwordOutput', { static: false }) password: ElementRef;
    private copyPassword() {
        const inputElement = <HTMLInputElement>this.password.nativeElement;
        inputElement.select();
        document.execCommand("copy");
    }
    // Generate password
    generatePassword() {
        if (this.lowercase === false && this.uppercase === false && this.numbers === false && this.symbols === false) {
            return this.newPasswordGenerate = "...";
        }
        // Create array from chosen checkboxes
        this.dictionary = [].concat(
            this.lowercase ? this.checkboxes[0].library.split("") : [],
            this.uppercase ? this.checkboxes[1].library.split("") : [],
            this.numbers ? this.checkboxes[2].library.split("") : [],
            this.symbols ? this.checkboxes[3].library.split("") : []
        );
        // Generate random password from array
        var newPasswordGenerate = "";
        for (var i = 0; i < this.passwordLenght; i++) {
            newPasswordGenerate += this.dictionary[Math.floor(Math.random() * this.dictionary.length)];
        }
        let newmuricAdd = newPasswordGenerate.substr(0, 5) + '1' + newPasswordGenerate.substr(5);
        let symbleAdd = newmuricAdd.substr(0, 9) + '$' + newmuricAdd.substr(9);
        let charecterAdd = symbleAdd.substr(0, 4) + 'G' + symbleAdd.substr(4);
        this.newPasswordGenerate = charecterAdd;
        //this.newPasswordGenerate = newPasswordGenerate;
        // Call copy function
        setTimeout(() => this.copyPassword());
        // Change text on button when clicked
        this.buttonLabel = "Copied!";
        setTimeout(() => { this.buttonLabel = "Generate" }, 1500);
    }
    constructor(
        public dialogRef: MatDialogRef<ResetPasswordComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
        private alertService: AlertService,
        private loaderService: LoaderService,
        private route: ActivatedRoute,
        private router: Router,
        public dialog: MatDialog,
        private cd: ChangeDetectorRef,
        private storageService: StorageService,
        private authenticationService: AuthenticationService,
        private encrypt: EncryptionService
    ) {
        this.currentUser = this.storageService.getItem('SignIn');
    }
    ngOnInit(): void {
        this.ChangePasswordFormGroup = this._formBuilder.group({
            old_password: ['', Validators.required],
            new_password: ['', [Validators.required, Validators.minLength(8), PasswordStrengthValidator]],
            //new_password: ['', [minCharactersOrNumericValidator]],
            confirm_password: ['', [Validators.required, confirmPasswordValidator]],
        });
        // this.generatePassword();
        // const encrypted = this.encrypt.encryptionAES('hello world');
        // const decrypted = this.encrypt.decryptionAES(encrypted);
        // console.log(encrypted);
        // console.log(decrypted);
    }
    getErrorMessage(controlName: string) {
        if (this.ChangePasswordFormGroup.controls[controlName].hasError('passwordStrength')) {
            return 'Must contain at least one digit, one uppercase, and one symbol';
        }
        else if (this.ChangePasswordFormGroup.controls[controlName].hasError('minlength')) {
            return 'Must be at least 8 characters'
        }
        // else if (this.ChangePasswordFormGroup.controls[controlName].hasError('minCharactersOrNumeric')) {
        //     return 'hhhhhhhh'
        // }
        else {
            return ''
        }
        //return 'Passwords must match'
    }
    changePasswordSubmit() {
        if (this.ChangePasswordFormGroup.status == 'INVALID') {
            return;
        }
        const reqData = { "ChangePassword": { "NewPassword": this.ChangePasswordFormGroup.value.new_password, "LoginSessionKey": this.currentUser.LoginSessionKey, "Password": this.ChangePasswordFormGroup.value.old_password } };
        this.authenticationService.changePassword(reqData).subscribe((res: any) => {
            if (res.ResponseCode == 200) {
                this.currentUser.ChangePassword = false;
                this.storageService.setItem('SignIn', this.currentUser);
                this.alertService.success(res.Message);
                this.dialogRef.close();
            } else {
                this.alertService.error(res.Message);
            }
        });
    }

    dialogClose(): void {
        this.dialogRef.close();
    }

}
export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent || !control) {
        return null;
    }
    const new_password = control.parent.get('new_password');
    const confirm_password = control.parent.get('confirm_password');
    if (!new_password || !confirm_password) {
        return null;
    }
    if (confirm_password.value === '') {
        return null;
    }
    if (new_password.value === confirm_password.value) {
        return null;
    }
    return { 'passwordsNotMatching': true };
};

export const PasswordStrengthValidator = function (control: AbstractControl): ValidationErrors | null {
    let value: string = control.value || '';
    let msg = "";
    if (!value) {
        return null
    }
    let upperCaseCharacters = /[A-Z]+/g;
    // let lowerCaseCharacters = /[a-z]+/g;
    let numberCharacters = /[0-9]+/g;
    let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (upperCaseCharacters.test(value) === false || numberCharacters.test(value) === false || specialCharacters.test(value) === false) {
        return {
            //passwordStrength: 'Password must contain at least two of the following: numbers, lowercase letters, uppercase letters, or special characters.'
            passwordStrength: 'hhh'
        }
    }
    /*let upperCaseCharacters = /[A-Z]+/g
    if (upperCaseCharacters.test(value) === false) {
      return { passwordStrength: `Upper case required` };
    }

    let lowerCaseCharacters = /[a-z]+/g
    if (lowerCaseCharacters.test(value) === false) {
      return { passwordStrength: `lower case required` };
    }


    let numberCharacters = /[0-9]+/g
    if (numberCharacters.test(value) === false) {
      return { passwordStrength: `number required` };
    }

    let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/
    if (specialCharacters.test(value) === false) {
      return { passwordStrength: `Special char required` };
    }
     return {
      passwordStrength:null
    }*/

}

export const minCharactersOrNumericValidator = function (control: AbstractControl): ValidationErrors | null {
    let value: string = control.value || '';
    let msg = "";
    if (!value) {
        return null
    }
    // let numberCharacters = /[[0-9]{6}]+/g;
    var numberCharacters = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    // console.log(numberCharacters.test(value), 'ssss', value,);
    if (numberCharacters.test(value) === false) {
        return {
            minCharactersOrNumeric: 'hhh'
        }
    }

}